// * -------------------------- MODULE --------------------------
export {default as Table} from './Table/components/Table'

export * from './Table/components/Table'
export * from './Table/redux/actions'
export * from './Table/redux/reducers'
export * from './Table/types/table'

